import styled from 'styled-components';

export const SwipeSectionStyle = styled.div`
  .event-swipe-section-infinity-toggle {
    margin-bottom: 20px;
  }
`;
